<template>
    <div class="app-navbar-content p-2">
        <b-row no-gutters>
            <b-col class="text-center">
                <b-button-group class="mr-3">
                    <b-button :to="{ name: 'assets', params: { market: 'crypto' } }">crypto</b-button>
                    <b-button :to="{ name: 'assets', params: { market: 'stock' } }">stocks</b-button>
                </b-button-group>
                <b-button-group>
                    <b-button :to="{ name: 'stats' }"><b-icon-graph-up /></b-button>
                    <b-button :to="{ name: 'dashboard' }" class="font-weight-bold">dashboard</b-button>
                    <b-button @click.prevent="refreshData"><b-icon icon="arrow-clockwise"></b-icon></b-button>
                </b-button-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    name: 'AppNavbar',
    methods: {
        refreshData() {
            this.$store.dispatch('syncData');
            this.$store.dispatch('checkForUpdates');
        },
    },
}
</script>

<style scoped>
.app-navbar-content {
    background-color: #343a40;
    opacity: 0.9;
    filter: alpha(opacity=80);
    border-radius: 10px;
    padding: 0px;
}
.app-navbar-content .btn:focus {
    box-shadow: none;
}
</style>